"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const config_1 = require("../utils/config");
const cookieManager_1 = require("../utils/cookieManager");
const refreshToken_1 = require("./refreshToken");
const setTokens_1 = require("./setTokens");
const boradcastListeners_1 = require("../utils/boradcastListeners");
const defaultParams = {
    env: config_1.Environment.prod,
    clientId: 'CHGG',
    refreshOnStart: true,
};
function init(params) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window !== 'undefined') {
            window.addEventListener('online', () => setTokens_1.checkRefresh());
        }
        const { env, domainUrl, clientId, refreshOnStart, resetPasswordSuccessRedirect } = Object.assign(Object.assign({}, defaultParams), params);
        config_1.setEnv(env);
        if (resetPasswordSuccessRedirect) {
            config_1.setResetPasswordRedirect(resetPasswordSuccessRedirect);
        }
        if (domainUrl) {
            config_1.setDomain(domainUrl);
        }
        config_1.setClientId(clientId);
        const id_token = cookieManager_1.getCookie('id_token');
        const access_token = cookieManager_1.getCookie('access_token');
        boradcastListeners_1.initBroadCastListener();
        if (id_token && access_token) {
            yield setTokens_1.setTokens(id_token, access_token, false);
            return;
        }
        if (id_token && refreshOnStart) {
            yield refreshToken_1.refreshToken();
        }
    });
}
exports.init = init;
